<script lang="ts">
  import { onMount } from "svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { init, record, save } from "./settings-general.store";

  $: canSubmit = $record != null && !!$record.companyName;

  async function onSubmit() {
    await save();
  }

  onMount(init);
</script>

{#if $record != null}
  <FormLayout on:submit={onSubmit} cancelEnabled={false} {canSubmit}>
    <FormField usageHelp="(200 caratteri)">
      <Input
        name="Denominazione Azienda"
        placeholder="denominazione"
        required={true}
        maxlength={200}
        bind:value={$record.companyName}
      />
    </FormField>
  </FormLayout>
{/if}
